import ChatWidget from "@/components/ChatWidget";
import { GetHopsitalOrderMessages, SendHopsitalOrderMessage } from "@/api/endpoints";
import "./style.css";

interface ChatWrapperProps {
    providerOrderId: string | number;
    className?: string;
    isChatOpen: boolean;
    setIsChatOpen: (isChatOpen: boolean) => void;
}

const ChatWrapper: React.FC<ChatWrapperProps> = ({ 
    providerOrderId, 
    className = "",
    isChatOpen,
    setIsChatOpen
}) => {
    return (
        <div className={`chat-wrapper-container ${className}`}>
            <ChatWidget 
                providerOrderId={providerOrderId}
                sendMessageAPI={SendHopsitalOrderMessage}
                getMessagesAPI={GetHopsitalOrderMessages}
                setIsChatOpen={setIsChatOpen}
                isChatOpen={isChatOpen}
            />
        </div>
    );
};

export default ChatWrapper;
